/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../../variables';

#ekg-area {
  .row {
    justify-content: space-between;
  }

  .MuiFormGroup-root.MuiRadioGroup-root {
    height: 200px;
  }

  .MuiFormGroup-root {
    min-width: 330px;
    column-gap: variables.$gap-between-lists;
  }
}
